const LOCAL_API_HOSTS = new Set(["127.0.0.1", "localhost"]);
const API_V1_PREFIX = "/api/v1";
const STABLE_UNVERSIONED_API_PATHS = new Set([
  "/api/auth/portal/exchange",
  "/api/notifications/telegram/webhook",
]);

const CANONICAL_API_PATHS: Record<string, string> = {
  "/api/price-chart": "/api/v1/market/price-chart",
  "/api/options-chain": "/api/v1/market/options-chain",
  "/api/tickers/search": "/api/v1/market/tickers/search",
  "/api/finviz": "/api/v1/market/finviz",
  "/api/quotes": "/api/v1/market/quotes",
};

export function generateRequestId(): string {
  if (typeof crypto !== "undefined" && crypto.randomUUID) {
    return crypto.randomUUID();
  }
  return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, (c) => {
    const r = (Math.random() * 16) | 0;
    return (c === "x" ? r : (r & 0x3) | 0x8).toString(16);
  });
}

export function getApiBaseUrl(): string {
  if (import.meta.env.VITE_DOCKER === "true") {
    return "";
  }

  const configured = (import.meta.env.VITE_API_URL || "").trim().replace(/\/+$/, "");
  if (configured) return configured;

  if (typeof window !== "undefined" && LOCAL_API_HOSTS.has(window.location.hostname)) {
    return `${window.location.protocol}//${window.location.hostname}:8080`;
  }

  return "";
}

export function canonicalApiPath(path: string): string {
  if (path.startsWith("http")) return path;
  if (path.startsWith(`${API_V1_PREFIX}/`)) return path;

  const [pathname, suffix = ""] = path.split(/([?#].*)/, 2);
  if (STABLE_UNVERSIONED_API_PATHS.has(pathname)) return path;

  const mappedPath = CANONICAL_API_PATHS[pathname];
  if (mappedPath) return `${mappedPath}${suffix}`;

  if (pathname.startsWith("/api/")) {
    return `${API_V1_PREFIX}${pathname.slice("/api".length)}${suffix}`;
  }

  return path;
}

export function resolveApiUrl(path: string): string {
  if (path.startsWith("http")) return path;
  return `${getApiBaseUrl()}${canonicalApiPath(path)}`;
}
